export enum FlexEvent {
  taskReceived = "taskReceived",
  taskUpdated = "taskUpdated",
  taskAccepted = "taskAccepted",
  taskCanceled = "taskCanceled",
  taskCompleted = "taskCompleted",
  taskRejected = "taskRejected",
  taskRescinded = "taskRescinded",
  taskTimeout = "taskTimeout",
  taskWrapup = "taskWrapup",
  pluginsLoaded = "pluginsLoaded",
  tokenUpdated = "tokenUpdated"
}
